"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNetworkBW = exports.SocialNetwork = exports.Settings = exports.Save = exports.PushToCloud = exports.Projects = exports.Move = exports.Form = exports.Fonts = exports.Delete = exports.Colors = exports.ColorWheel = exports.AcceptButton = exports.Mail = exports.Accept = exports.Unarchive = exports.Restore = exports.LargePreview32 = exports.Blueprint = exports.Archive = exports.Tag = exports.PDF2 = exports.Navigation = exports.Disable = exports.AnalyticsBarChart = exports.Analytics = exports.ReferralLove = exports.Text = exports.Table = exports.Share = exports.Rate = exports.Preview = exports.PayNow = exports.Name = exports.InviteMedium = exports.Integrations = exports.FixedCost = exports.Dropdown = exports.GiftGrey = exports.Code = exports.Clone = exports.Bell = exports.Account = exports.ColorRemoveTemplate = exports.ColorCreateTemplate = exports.OldStarUnselected = exports.OldStar = exports.FontSquare = exports.Video = exports.Splash = void 0;
exports.SettingsTeam = exports.SettingsSubscription = exports.SettingsSubdomain = exports.SettingsSecurity = exports.SettingsNotifications = exports.SettingsLinkPreview = exports.SettingsIntegrations = exports.SettingsFonts = exports.SettingsCustomDomain = exports.SettingsBrand = exports.SettingsApi = exports.SettingsAnalytics = exports.SettingsAccount = exports.Security = exports.Link = exports.QuoteBlockDisabledColor = exports.AcceptBlockDisabledColor = exports.BlockAcceptColor75 = exports.BlockEmbedColor75 = exports.BlockImageColor75 = exports.BlockVideoColor75 = exports.BlockQuoteColor75 = exports.BlockTextColor75 = exports.ChangeOwner = exports.Taxes = void 0;
var Splash_svg_1 = __importDefault(require("@ClientAssets/icons/Splash.svg"));
exports.Splash = Splash_svg_1.default;
var Video_svg_1 = __importDefault(require("@ClientAssets/icons/Video.svg"));
exports.Video = Video_svg_1.default;
var FontSquare_svg_1 = __importDefault(require("@ClientAssets/icons/FontSquare.svg"));
exports.FontSquare = FontSquare_svg_1.default;
var OldStar_svg_1 = __importDefault(require("@ClientAssets/icons/OldStar.svg"));
exports.OldStar = OldStar_svg_1.default;
var OldStarUnselected_svg_1 = __importDefault(require("@ClientAssets/icons/OldStarUnselected.svg"));
exports.OldStarUnselected = OldStarUnselected_svg_1.default;
var create_template_svg_1 = __importDefault(require("@ClientAssets/icons/color/create-template.svg"));
exports.ColorCreateTemplate = create_template_svg_1.default;
var remove_template_svg_1 = __importDefault(require("@ClientAssets/icons/color/remove-template.svg"));
exports.ColorRemoveTemplate = remove_template_svg_1.default;
var Account_svg_1 = __importDefault(require("@ClientAssets/icons/Account.svg"));
exports.Account = Account_svg_1.default;
var Bell_svg_1 = __importDefault(require("@ClientAssets/icons/Bell.svg"));
exports.Bell = Bell_svg_1.default;
var Clone_svg_1 = __importDefault(require("@ClientAssets/icons/Clone.svg"));
exports.Clone = Clone_svg_1.default;
var Code_svg_1 = __importDefault(require("@ClientAssets/icons/Code.svg"));
exports.Code = Code_svg_1.default;
var gift_grey_svg_1 = __importDefault(require("@ClientAssets/icons/gift-grey.svg"));
exports.GiftGrey = gift_grey_svg_1.default;
var Dropdown_svg_1 = __importDefault(require("@ClientAssets/icons/Dropdown.svg"));
exports.Dropdown = Dropdown_svg_1.default;
var FixedCost_svg_1 = __importDefault(require("@ClientAssets/icons/FixedCost.svg"));
exports.FixedCost = FixedCost_svg_1.default;
var Integrations_svg_1 = __importDefault(require("@ClientAssets/icons/Integrations.svg"));
exports.Integrations = Integrations_svg_1.default;
var Invite_med_svg_1 = __importDefault(require("@ClientAssets/icons/Invite_med.svg"));
exports.InviteMedium = Invite_med_svg_1.default;
var Name_svg_1 = __importDefault(require("@ClientAssets/icons/Name.svg"));
exports.Name = Name_svg_1.default;
var PayNow_svg_1 = __importDefault(require("@ClientAssets/icons/PayNow.svg"));
exports.PayNow = PayNow_svg_1.default;
var Preview_svg_1 = __importDefault(require("@ClientAssets/icons/Preview.svg"));
exports.Preview = Preview_svg_1.default;
var Rate_svg_1 = __importDefault(require("@ClientAssets/icons/Rate.svg"));
exports.Rate = Rate_svg_1.default;
var Share_svg_1 = __importDefault(require("@ClientAssets/icons/Share.svg"));
exports.Share = Share_svg_1.default;
var Table_svg_1 = __importDefault(require("@ClientAssets/icons/Table.svg"));
exports.Table = Table_svg_1.default;
var Text_svg_1 = __importDefault(require("@ClientAssets/icons/Text.svg"));
exports.Text = Text_svg_1.default;
var referral_love_svg_1 = __importDefault(require("@ClientAssets/icons/large/referral-love.svg"));
exports.ReferralLove = referral_love_svg_1.default;
var Analytics_svg_1 = __importDefault(require("@ClientAssets/icons/Analytics.svg"));
exports.Analytics = Analytics_svg_1.default;
var analytics_bar_svg_1 = __importDefault(require("@ClientAssets/icons/features/analytics-bar.svg"));
exports.AnalyticsBarChart = analytics_bar_svg_1.default;
var Disable_svg_1 = __importDefault(require("@ClientAssets/icons/Disable.svg"));
exports.Disable = Disable_svg_1.default;
var Navigation_svg_1 = __importDefault(require("@ClientAssets/icons/Navigation.svg"));
exports.Navigation = Navigation_svg_1.default;
var PDF2_svg_1 = __importDefault(require("@ClientAssets/icons/PDF2.svg"));
exports.PDF2 = PDF2_svg_1.default;
var Tag_svg_1 = __importDefault(require("@ClientAssets/icons/Tag.svg"));
exports.Tag = Tag_svg_1.default;
var archive_svg_1 = __importDefault(require("@ClientAssets/icons/archive.svg"));
exports.Archive = archive_svg_1.default;
var blueprint_svg_1 = __importDefault(require("@ClientAssets/icons/blueprint.svg"));
exports.Blueprint = blueprint_svg_1.default;
var preview_32_svg_1 = __importDefault(require("@ClientAssets/icons/large/preview-32.svg"));
exports.LargePreview32 = preview_32_svg_1.default;
var restore_svg_1 = __importDefault(require("@ClientAssets/icons/restore.svg"));
exports.Restore = restore_svg_1.default;
var unarchive_svg_1 = __importDefault(require("@ClientAssets/icons/unarchive.svg"));
exports.Unarchive = unarchive_svg_1.default;
var Accept_svg_1 = __importDefault(require("@ClientAssets/icons/Accept.svg"));
exports.Accept = Accept_svg_1.default;
var Mail_svg_1 = __importDefault(require("@ClientAssets/icons/Mail.svg"));
exports.Mail = Mail_svg_1.default;
var AcceptButton_svg_1 = __importDefault(require("@ClientAssets/icons/AcceptButton.svg"));
exports.AcceptButton = AcceptButton_svg_1.default;
var ColorWheel_svg_1 = __importDefault(require("@ClientAssets/icons/ColorWheel.svg"));
exports.ColorWheel = ColorWheel_svg_1.default;
var Colors_svg_1 = __importDefault(require("@ClientAssets/icons/Colors.svg"));
exports.Colors = Colors_svg_1.default;
var Delete_svg_1 = __importDefault(require("@ClientAssets/icons/Delete.svg"));
exports.Delete = Delete_svg_1.default;
var Fonts_svg_1 = __importDefault(require("@ClientAssets/icons/Fonts.svg"));
exports.Fonts = Fonts_svg_1.default;
var Form_svg_1 = __importDefault(require("@ClientAssets/icons/Form.svg"));
exports.Form = Form_svg_1.default;
var Move_svg_1 = __importDefault(require("@ClientAssets/icons/Move.svg"));
exports.Move = Move_svg_1.default;
var Projects_svg_1 = __importDefault(require("@ClientAssets/icons/Projects.svg"));
exports.Projects = Projects_svg_1.default;
var PushToCloud_svg_1 = __importDefault(require("@ClientAssets/icons/PushToCloud.svg"));
exports.PushToCloud = PushToCloud_svg_1.default;
var Save_svg_1 = __importDefault(require("@ClientAssets/icons/Save.svg"));
exports.Save = Save_svg_1.default;
var Settings_svg_1 = __importDefault(require("@ClientAssets/icons/Settings.svg"));
exports.Settings = Settings_svg_1.default;
var SocialNetwork_svg_1 = __importDefault(require("@ClientAssets/icons/SocialNetwork.svg"));
exports.SocialNetwork = SocialNetwork_svg_1.default;
var SocialNetworkBW_svg_1 = __importDefault(require("@ClientAssets/icons/SocialNetworkBW.svg"));
exports.SocialNetworkBW = SocialNetworkBW_svg_1.default;
var Taxes_svg_1 = __importDefault(require("@ClientAssets/icons/Taxes.svg"));
exports.Taxes = Taxes_svg_1.default;
var ChangeOwner_svg_1 = __importDefault(require("@ClientAssets/icons/ChangeOwner.svg"));
exports.ChangeOwner = ChangeOwner_svg_1.default;
var Link_svg_1 = __importDefault(require("@ClientAssets/icons/Link.svg"));
exports.Link = Link_svg_1.default;
var Security_svg_1 = __importDefault(require("@ClientAssets/icons/Security.svg"));
exports.Security = Security_svg_1.default;
var settings_account_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-account.svg"));
exports.SettingsAccount = settings_account_svg_1.default;
var settings_analytics_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-analytics.svg"));
exports.SettingsAnalytics = settings_analytics_svg_1.default;
var settings_api_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-api.svg"));
exports.SettingsApi = settings_api_svg_1.default;
var settings_brand_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-brand.svg"));
exports.SettingsBrand = settings_brand_svg_1.default;
var settings_custom_domain_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-custom-domain.svg"));
exports.SettingsCustomDomain = settings_custom_domain_svg_1.default;
var settings_fonts_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-fonts.svg"));
exports.SettingsFonts = settings_fonts_svg_1.default;
var settings_integrations_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-integrations.svg"));
exports.SettingsIntegrations = settings_integrations_svg_1.default;
var settings_link_preview_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-link-preview.svg"));
exports.SettingsLinkPreview = settings_link_preview_svg_1.default;
var settings_notifications_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-notifications.svg"));
exports.SettingsNotifications = settings_notifications_svg_1.default;
var settings_security_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-security.svg"));
exports.SettingsSecurity = settings_security_svg_1.default;
var settings_subdomain_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-subdomain.svg"));
exports.SettingsSubdomain = settings_subdomain_svg_1.default;
var settings_subscription_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-subscription.svg"));
exports.SettingsSubscription = settings_subscription_svg_1.default;
var settings_team_svg_1 = __importDefault(require("@ClientAssets/icons/settings/settings-team.svg"));
exports.SettingsTeam = settings_team_svg_1.default;
var block_text_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-text-75.svg"));
exports.BlockTextColor75 = block_text_75_svg_1.default;
var block_quote_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-quote-75.svg"));
exports.BlockQuoteColor75 = block_quote_75_svg_1.default;
var block_video_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-video-75.svg"));
exports.BlockVideoColor75 = block_video_75_svg_1.default;
var block_image_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-image-75.svg"));
exports.BlockImageColor75 = block_image_75_svg_1.default;
var block_embed_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-embed-75.svg"));
exports.BlockEmbedColor75 = block_embed_75_svg_1.default;
var block_accept_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-accept-75.svg"));
exports.BlockAcceptColor75 = block_accept_75_svg_1.default;
var accept_block_disabled_svg_1 = __importDefault(require("@ClientAssets/icons/color/accept-block-disabled.svg"));
exports.AcceptBlockDisabledColor = accept_block_disabled_svg_1.default;
var quote_block_disabled_svg_1 = __importDefault(require("@ClientAssets/icons/color/quote-block-disabled.svg"));
exports.QuoteBlockDisabledColor = quote_block_disabled_svg_1.default;
